import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/tags/importer/tagsImporterActions'

export default importerReducers(actions)
